import type { RouteConfig } from 'vue-router'

import { ensureToken } from '@/router/guards/ensureToken'

export default [
  {
    path: '/analytics',
    name: 'analytics',
    meta: {
      isMarketPlacesEnabled: true
    },
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/Analytics.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/smart-tariff-classifications',
    name: 'smartTariffClassifier',
    meta: {
      isMarketPlacesEnabled: true
    },
    component: () => import(/* webpackChunkName: "resources-views" */ './views/TariffClassifications.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/fee-tracker-pro',
    name: 'feeTrackerPro',
    meta: {
      isMarketPlacesEnabled: true,
      isFeeTrackerActive: true

    },
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/FeeTrackerPro.vue'),
    beforeEnter: ensureToken
  },
  {
    path: '/marketplace-overview',
    name: 'marketplaceOverview',
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/MarketplaceOverview.vue'),
    meta: {
      isMarketPlacesEnabled: true,
      sv1: true
    },
    beforeEnter: ensureToken
  },
  {
    path: '/service-fees',
    name: 'ServiceFees',
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/ServiceFees.vue'),
    meta: {
      isMarketPlacesEnabled: true,
      sv1: true
    },
    beforeEnter: ensureToken
  },
  {
    path: '/product-sales',
    name: 'ProductSales',
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/ProductSales.vue'),
    meta: {
      isMarketPlacesEnabled: true,
      sv1: true
    },
    beforeEnter: ensureToken
  },
  {
    path: '/product-profitability',
    name: 'ProductProfitability',
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/ProductProfitability.vue'),
    meta: {
      isMarketPlacesEnabled: true,
      sv1: true
    },
    beforeEnter: ensureToken
  },
  {
    path: '/product-order-metrics',
    name: 'ProductOrderMetrics',
    component: () => import(/* webpackChunkName: "marketplace-views" */ './views/ProductOrderMetrics.vue'),
    meta: {
      isMarketPlacesEnabled: true,
      sv1: true
    },
    beforeEnter: ensureToken
  }
] as Array<RouteConfig>
